(() => {
  const bar = document.getElementById('vq-sticky-atc');
  if (!bar) return;

  const priceEl = bar.querySelector('.vq-sticky-atc__price');
  const variantLabel = bar.querySelector('.vq-sticky-atc__variant');
  const imgEl = bar.querySelector('.vq-sticky-atc__img');
  const cartBtn = bar.querySelector('.vq-sticky-atc__btn');
  const sectionId = bar.dataset.sectionId;

  // Shopify gibt Preise in Cent zurück (z.B. 15999 = 159,99 €)
  const toPrice = (cents) => {
    const format = bar.dataset.moneyFormat || window.Shopify?.money_format || '{{amount}} €';
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return format
      .replace('{{amount_with_comma_separator}}', value)
      .replace('{{amount}}', value);
  };

  let scrollObserver, debounceTimer, footerInView = false, barVisible = false;

  const root = document.documentElement;
  // Abstand, um den die Widgets am unteren Rand (Bonusprogramm, Barrierefreiheit)
  // hochgeschoben werden müssen, damit sie die Leiste nicht überdecken.
  // Basis der Widgets ist bottom: 20px, dazu 12px Abstand zur Leiste.
  const WIDGET_BASE_BOTTOM = 20;
  const WIDGET_GAP = 12;

  const updateWidgetOffset = () => {
    if (!barVisible) {
      root.style.setProperty('--vq-sticky-atc-offset', '0px');
      return;
    }
    // Ungetransformierte Höhe der Leiste über der Viewport-Unterkante
    const barBottom = parseFloat(getComputedStyle(bar).bottom) || 0;
    const clearance = bar.offsetHeight + barBottom;
    const offset = Math.max(0, Math.round(clearance + WIDGET_GAP - WIDGET_BASE_BOTTOM));
    root.style.setProperty('--vq-sticky-atc-offset', `${offset}px`);
  };

  const showBar = (show) => {
    barVisible = show;
    bar.classList.toggle('vq-sticky-atc--visible', show);
    bar.setAttribute('aria-hidden', String(!show));
    root.classList.toggle('vq-sticky-atc-active', show);
    updateWidgetOffset();
  };

  // Dawn-Theme: ATC-Button befindet sich innerhalb des product-form Web Components
  const findRealBtn = () =>
    (sectionId && document.getElementById(`ProductSubmitButton-${sectionId}`)) ||
    document.querySelector('product-form button[name="add"]');

  const updateBar = (variant) => {
    if (!variant) return;

    if (priceEl) priceEl.textContent = toPrice(variant.price);

    if (variantLabel) {
      if (variant.title && variant.title !== 'Default Title') {
        variantLabel.textContent = variant.title;
        variantLabel.style.display = '';
      } else {
        variantLabel.style.display = 'none';
      }
    }

    if (variant.featured_image?.src && imgEl) {
      // srcset zuerst entfernen, sonst ignoriert der Browser das neue src
      imgEl.removeAttribute('srcset');
      imgEl.src = variant.featured_image.src;
    }
  };

  // Dawn rendert die aktuell gewählte Variante als JSON in einem script-Tag
  const getInitialVariant = () => {
    try {
      return JSON.parse(document.querySelector('script[data-selected-variant]')?.textContent);
    } catch (_) {
      return null;
    }
  };

  const updateButton = () => {
    // Dawn setzt das native disabled-Attribut direkt am Button
    cartBtn.disabled = findRealBtn()?.disabled ?? false;
  };

  const watchScroll = () => {
    scrollObserver?.disconnect();
    const realBtn = findRealBtn();
    if (!realBtn) return;

    // Sticky-ATC einblenden sobald der echte Button nach oben rausgescrollt ist
    scrollObserver = new IntersectionObserver(
      ([entry]) => {
        if (footerInView) return;
        showBar(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );

    scrollObserver.observe(realBtn);
  };

  const variantChanged = (variant) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      watchScroll();
      if (variant) updateBar(variant);
      updateButton();
    }, 60);
  };

  // Initialisierung
  watchScroll();
  updateButton();
  updateBar(getInitialVariant());

  // Beim Laden prüfen ob schon nach unten gescrollt wurde
  requestAnimationFrame(() => {
    const realBtn = findRealBtn();
    if (realBtn && !footerInView) showBar(realBtn.getBoundingClientRect().top < 0);
  });

  // Leiste verstecken wenn Footer sichtbar wird
  const footer = document.querySelector('footer.footer');
  if (footer) {
    new IntersectionObserver(
      ([entry]) => {
        footerInView = entry.isIntersecting;
        if (footerInView) {
          showBar(false);
        } else {
          const realBtn = findRealBtn();
          if (realBtn) showBar(realBtn.getBoundingClientRect().top < 0);
        }
      },
      { threshold: 0 }
    ).observe(footer);
  }

  // Dawn publiziert den Variantenwechsel über pubsub
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event?.data;
      if (!data || (sectionId && data.sectionId !== sectionId)) return;
      variantChanged(data.variant ?? null);
    });
  }

  // Fallback für Sektionen, die stattdessen ein DOM-Event feuern
  document.addEventListener('variant:change', (e) => {
    variantChanged(e.detail?.variant ?? null);
  });

  // Bei Größenänderung ändert sich die Höhe der Leiste (Breakpoint / Umbruch)
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateWidgetOffset, 150);
  });

  // Klick auf Sticky-Button löst den echten ATC-Button aus
  cartBtn.addEventListener('click', () => findRealBtn()?.click());
})();
